module.exports = new __parcel__URL__("bench_press_level_1.aa557076.png").toString();